import { render, staticRenderFns } from "./export.vue?vue&type=template&id=386f2ae4&scoped=true"
import script from "./export.vue?vue&type=script&lang=js"
export * from "./export.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386f2ae4",
  null
  
)

export default component.exports